<template>
  <div>
    <div class="print-ag">
      <el-button type="primary" size="small" v-print="'#printInstance'" plain>打印
      </el-button>
    
    </div>
    <div class="img-container">
      <div class="table-container" id="printInstance">
        <div class="department">{{this.printData.department}}</div>
        <div class="date-time">
          <span class="year">{{this.printData.year}}</span>
          <span class="month">{{this.printData.month}}</span>
          <span class="day">{{this.printData.day}}</span>
        </div>
        <div class="payee">{{this.printData.other_company}}</div>
        <div class="payment">{{this.printData.content}}</div>
        <div class="bank">{{this.printData.other_company_bank}}</div>
        <div class="account">{{this.printData.other_company_number}}</div>
        <div class="coin_name">{{this.printData.coin_name}}</div>
        <div class="money">
          <span class="el-icon-circle-close"></span>
          <span v-for="(item,index) in this.printData.cnNum" :key="index">{{item}}</span>

        </div>
        <div class="num-money">{{this.printData.coin_Enname}}{{this.printData.money_op}}
        </div>
        <div class="correlation">
          <!-- <span class="session">xxx</span>
          <span class="session">xxx</span>
          <span class="session">xxx</span>
          <span class="session">xxxx</span> -->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { toDx } from '@/utils/toTx'
import dayjs from 'dayjs';
export default {
  name: 'btnPrintFileSpendMoney',
  data() {
    return {
      printData: {}
    }
  },
  created() {
    let printData = JSON.parse(sessionStorage.getItem('ag-print-spend-money'));
    this.printData = {
      ...printData,
      cnNum: this.dealNumber(printData.money),
      ...this.dealDate(printData.created_at),
      money_op: this.formatNum(printData.money)
    }
    console.log(this.printData, 'this.print');
  },
  methods: {
    dealDate(time) {
      let year = dayjs(time).year()
      let month = dayjs(time).month() + 1;// dayjs月份为0-11
      let day = dayjs(time).date()
      return { year, month, day }
      console.log(year, month, day, '---------1');
    },
    dealNumber(num) {
      let s1 = num.toString()
      let cnNum
      if (s1.indexOf('.') > 0) {
        s1 = s1.replace('.', '')
      } else {
        s1 = (num * 100).toString()
      }
      let arrNum = s1.split('');
      console.log(arrNum, 'arrnum');
      cnNum = arrNum.map(item => {
        return toDx(item)
      })

      return cnNum
    },
    formatNum(num) {
      let st1 = String(num); // 将浮点数转换为字符串
      let index = st1.indexOf('.'); // 取小数点下标
      if (index < 0) {
        return this.toThousands(num)
      }
      let st2 = st1.slice(0, index); // 将小数点前面的字符串截取出来
      let len = st2.length;
      if (len < 3) return st2.concat(st1.slice(index));
      let r = len % 3;
      return (r > 0 ?
        st2.slice(0, r) + ',' + st2.slice(r, len).match(/\d{3}/g).join() :
        st2.slice(r, len).match(/\d{3}/g).join())
        .concat(st1.slice(index));
    },

    toThousands(num) {
      let result = '', counter = 0;
      num = (num || 0).toString();
      for (let i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) { result = ',' + result; }
      }
      return result;
    }

  }
}
</script>

<style lang="scss" scoped>
.print-ag {
  text-align: left;
}

.img-container {
  background: url("./invoice.jpg") no-repeat;
  background-size: 842px 443px;
  margin: 0 auto;
  width: 842px;
  height: 443px;
}

.table-container {
  font-size: 16px;
  width: 842px;
  height: 443px;
  position: relative;
}

.department {
  position: absolute;
  left: 200px;
  top: 100px;
}

.date-time {
  position: absolute;
  left: 400px;
  top: 100px;
  display: flex;
}

.date-time span {
  margin-left: 55px;
}

.payee {
  position: absolute;
  left: 220px;
  top: 146px;
}

.payment {
  position: absolute;
  left: 650px;
  top: 156px;
  width: 300px;
}

.bank {
  position: absolute;
  left: 220px;
  top: 200px;
}

.account {
  position: absolute;
  left: 220px;
  top: 258px;
}

.coin_name {
  position: absolute;
  left: 220px;
  top: 325px;
}

.money {
  width: 700px;
  height: 14px;
  position: absolute;
  left: 150px;
  // left: 335px;
  top: 340px;
  display: flex;

  /* flex-direction: row-reverse; */
  justify-content: flex-end;
}

.money span {
  width: 32px;
  // margin-right: 15px;
  margin-left: 25px;
  text-align: center;
  display: inline-block;

  &:last-child {
    margin-right: 0;
  }
}

.num-money {
  position: absolute;
  left: 895px;
  top: 384px;
}

.correlation {
  position: absolute;
  left: 27px;
  top: 390px;
  display: flex;
}

.session {
  width: 200px;
  text-align: center;
}
</style>